module.exports = __webpack_public_path__ + "static/media/asian-woman-farmer-using-digital-tablet.8c485930.jpg";